import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pifu",
  "use": "icon-pifu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pifu\"><path d=\"M1020.75354075 473.16385185l-150.68425483 150.68425482L745.01688889 498.79570963V900.36148148H271.99260445V499.57243259l-124.27567408 124.27567408L-2.19060148 473.16385185l274.18320593-274.18320593h83.10935703c-0.77672297 3.10689185-0.77672297 5.43706075-0.77672296 7.76722963 0 48.93354667 70.68178963 87.76969482 157.67476148 87.76969482s157.67476148-38.83614815 157.67476148-87.76969482c0-2.33016889 0-4.66033778-0.85439526-7.76722963H745.01688889v0.77672297l0.77672296-0.77672297 274.9599289 274.18320593z\" p-id=\"3949\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/pifu.svg
// module id = ekAn
// module chunks = 21